export enum ItemId {
  FastInserter = 'fast-inserter',
  Inserter = 'inserter',
  LongHandedInserter = 'long-handed-inserter',
  MineControlTower = 'mine-control-tower',
  MiningDrill = 'mining-drill',
  Module = 'module',
  NuclearPowerPlant = 'nuclear-power-plant',
  Pipe = 'pipe',
  ProductivityLimitation = 'productivity-module',
  Pumpjack = 'pumpjack',
  StackInserter = 'stack-inserter',
  Water = 'water',
}
